(function() {
  function fixMoneySpaces() {
    document.querySelectorAll('[shipping-message]').forEach(function(el) {
      var text = el.textContent;
      if (!text) return;

      var fixed = text.replace(/([^\s\d,.])(\s+)(\d)/g, function(match, symbol, space, digit) {
        return symbol + digit;
      });

      if (fixed !== text) el.textContent = fixed;
    });
  }

  function getCartDrawerComponent(drawerCart) {
    if (drawerCart && drawerCart.closest) return drawerCart.closest('cart-drawer-component');
    return document.querySelector('cart-drawer-component');
  }

  function refreshDrawerLayout(drawerCart) {
    var component = getCartDrawerComponent(drawerCart);
    if (!component) return;

    /* The component itself carries .drawer, so look at it before its children
       (27 Oct: the old lookup found nothing and never ran). */
    var drawer = component.matches('.drawer') ? component : (component.querySelector('.drawer[drawer-type="cart-drawer"]') || component.querySelector('.drawer'));
    var action = component.querySelector('.drawer__action__btn');
    if (!drawer || !action) return;

    var actionHeight = Math.ceil(action.getBoundingClientRect().height);
    if (actionHeight > 0) drawer.style.setProperty('--set-container-height', actionHeight + 'px');

    /* Re-measure whenever the checkout bar changes height (fonts, trust badges,
       iPhone text wrapping), so the item list never runs underneath it. */
    if (window.ResizeObserver && !action.__ccdResizeBound) {
      action.__ccdResizeBound = true;
      new ResizeObserver(function() { refreshDrawerLayout(document.querySelector('drawer-cart')); }).observe(action);
    }

    var bodyWrapper = component.querySelector('.drawer__body__wrapper');
    if (bodyWrapper) {
      bodyWrapper.style.overflowY = 'auto';
      bodyWrapper.style.webkitOverflowScrolling = 'touch';
    }
  }

  function scheduleDrawerLayoutRefresh(drawerCart) {
    var delays = [0, 80, 220, 500];

    delays.forEach(function(delay) {
      setTimeout(function() {
        window.requestAnimationFrame(function() {
          refreshDrawerLayout(drawerCart || document.querySelector('drawer-cart'));
        });
      }, delay);
    });
  }

  function bindRecommendationImageRefresh(drawerCart) {
    var wrap = drawerCart && drawerCart.querySelector('.cart__recommendation__position');
    if (!wrap) return;

    wrap.querySelectorAll('img').forEach(function(img) {
      if (img.dataset.ccdLayoutRefreshBound) return;
      img.dataset.ccdLayoutRefreshBound = 'true';
      img.addEventListener('load', function() { scheduleDrawerLayoutRefresh(drawerCart); });
      img.addEventListener('error', function() { scheduleDrawerLayoutRefresh(drawerCart); });
    });
  }

  function drawerHasItems(drawerCart) {
    if (!drawerCart) return false;
    if (drawerCart.querySelector('.empty__cart')) return false;
    if (drawerCart.querySelector('.cart__drawer__item')) return true;

    var count = parseInt(drawerCart.getAttribute('data-cartItemCount') || drawerCart.dataset.cartitemcount || '0', 10);
    return count > 0;
  }

  function recommendationHasSlides(wrap) {
    return !!(wrap && wrap.querySelector('.swiper-slide'));
  }

  function getRecommendationTrack(wrap) {
    return wrap && (wrap.querySelector('.swiper-wrapper') || wrap.querySelector('[product-recommendation]'));
  }

  function getSlidePositions(track) {
    var slides = Array.prototype.slice.call(track.querySelectorAll('.swiper-slide'));
    if (!slides.length) return [];

    var firstOffset = slides[0].offsetLeft;
    return slides.map(function(slide) {
      return Math.max(0, slide.offsetLeft - firstOffset);
    });
  }

  function getCurrentSlideIndex(track, positions) {
    var current = track.scrollLeft;
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var closestIndex = 0;
    var closestDistance = Infinity;

    if (current >= max - 4) return positions.length - 1;

    for (var i = 0; i < positions.length; i++) {
      var distance = Math.abs(positions[i] - current);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = i;
      }
    }

    return closestIndex;
  }

  function scrollRecommendations(wrap, direction) {
    var track = getRecommendationTrack(wrap);
    if (!track) return;

    var positions = getSlidePositions(track);
    if (!positions.length) return;

    var currentIndex = getCurrentSlideIndex(track, positions);
    var targetIndex = Math.max(0, Math.min(positions.length - 1, currentIndex + direction));
    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var targetLeft = Math.min(positions[targetIndex], max);

    if (track.scrollTo) {
      track.scrollTo({ left: targetLeft, behavior: 'smooth' });
    } else {
      track.scrollLeft = targetLeft;
    }

    track.style.transform = 'none';
  }

  function resetRecommendationScroll(wrap) {
    var track = getRecommendationTrack(wrap);
    if (!track) return;

    track.scrollLeft = 0;
    track.style.transform = 'none';

    var container = wrap.querySelector('.swiper-container');
    if (container) container.scrollLeft = 0;
  }

  function ensureRecommendationHeader(drawerCart) {
    var wrap = drawerCart && drawerCart.querySelector('.cart__recommendation__position');
    if (!wrap || !recommendationHasSlides(wrap) || wrap.querySelector('.ccd-rec-header')) return;

    var heading = wrap.querySelector('.recommendation__head, .ccd-rec-heading');
    if (!heading) return;

    var header = document.createElement('div');
    header.className = 'ccd-rec-header';

    var nav = document.createElement('div');
    nav.className = 'ccd-rec-nav';
    nav.innerHTML = '<button class="ccd-rec-nav-btn" type="button" aria-label="Previous recommended product" data-ccd-rec-prev><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button class="ccd-rec-nav-btn" type="button" aria-label="Next recommended product" data-ccd-rec-next><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6L15 12L9 18" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    heading.parentNode.insertBefore(header, heading);
    header.appendChild(heading);
    header.appendChild(nav);

    nav.querySelector('[data-ccd-rec-prev]').addEventListener('click', function() {
      scrollRecommendations(wrap, -1);
    });
    nav.querySelector('[data-ccd-rec-next]').addEventListener('click', function() {
      scrollRecommendations(wrap, 1);
    });
  }

  function activateRecommendations(drawerCart, resetTrack) {
    if (!drawerCart) return;

    var hasItems = drawerHasItems(drawerCart);
    drawerCart.classList.toggle('ccd-cart-has-items', hasItems);

    var wrap = drawerCart.querySelector('.cart__recommendation__position');
    if (!wrap) {
      scheduleDrawerLayoutRefresh(drawerCart);
      return;
    }

    if (!hasItems || !recommendationHasSlides(wrap)) {
      wrap.style.display = 'none';
      scheduleDrawerLayoutRefresh(drawerCart);
      return;
    }

    wrap.style.display = '';
    wrap.style.visibility = '';

    wrap.querySelectorAll('cart-recommendation').forEach(function(rec) {
      rec.classList.add('set--as--carousel', 'recommendations-active', 'products-ready');
      rec.setAttribute('aria-hidden', 'false');
      rec.style.display = '';
      rec.style.visibility = '';
    });

    ensureRecommendationHeader(drawerCart);
    bindRecommendationImageRefresh(drawerCart);
    if (resetTrack) resetRecommendationScroll(wrap);
    scheduleDrawerLayoutRefresh(drawerCart);
  }

  function findRecommendationBlock(drawerCart) {
    if (!drawerCart) return null;

    var inside = drawerCart.querySelector('.cart__recommendation__position');
    if (inside && recommendationHasSlides(inside)) return inside;

    var component = drawerCart.closest('cart-drawer-component');
    var nearby = component && component.querySelector('.cart__recommendation__position');
    if (nearby && recommendationHasSlides(nearby)) return nearby;

    return null;
  }

  function patchDrawerCartRender() {
    var DrawerCart = customElements.get('drawer-cart');
    if (!DrawerCart || !DrawerCart.prototype || DrawerCart.prototype.__ccdRecommendationPatch) return false;

    var originalRenderCartContents = DrawerCart.prototype.renderCartContents;
    if (typeof originalRenderCartContents !== 'function') return false;

    DrawerCart.prototype.renderCartContents = function(data) {
      var preservedRecommendations = findRecommendationBlock(this);

      originalRenderCartContents.call(this, data);

      var currentRecommendations = this.querySelector('.cart__recommendation__position');

      if (!currentRecommendations && preservedRecommendations) {
        this.appendChild(preservedRecommendations);
      }

      fixMoneySpaces();
      activateRecommendations(this, true);
      scheduleDrawerLayoutRefresh(this);
    };

    DrawerCart.prototype.__ccdRecommendationPatch = true;
    return true;
  }

  function patchWhenReady() {
    if (patchDrawerCartRender()) {
      document.querySelectorAll('drawer-cart').forEach(function(drawerCart) {
        activateRecommendations(drawerCart, false);
        scheduleDrawerLayoutRefresh(drawerCart);
      });
      fixMoneySpaces();
      return;
    }

    setTimeout(patchWhenReady, 100);
  }

  function updateRecommendationVariant(select) {
    var info = select && select.closest('.ccd-rec-info');
    if (!info) return;

    var idInput = info.querySelector('.ccd-rec-form input[name="id"]');
    if (idInput) idInput.value = select.value;

    var selected = select.options[select.selectedIndex];
    var price = selected && selected.getAttribute('data-price');
    var priceLabel = info.querySelector('.ccd-rec-price-label');
    if (price && priceLabel) priceLabel.textContent = price;
  }

  function setRecommendationButton(button, text, disabled) {
    if (!button) return;
    var label = button.querySelector('.ccd-rec-btn-text') || button;
    label.textContent = text;
    button.disabled = !!disabled;
  }

  function submitRecommendationForm(event) {
    var form = event.target && event.target.closest ? event.target.closest('.ccd-rec-form') : null;
    if (!form) return;

    event.preventDefault();
    event.stopPropagation();

    var idInput = form.querySelector('input[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var variantId = idInput && parseInt(idInput.value, 10);
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    var button = form.querySelector('.ccd-rec-add-btn');

    if (!variantId) return;
    if (!quantity || quantity < 1) quantity = 1;

    setRecommendationButton(button, 'Adding...', true);

    var sectionsString = '';
    try {
      sectionsString = HELPER_UTIL.sectionRenderUtil('cart-drawer').getSectionsString();
    } catch (err) {}

    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var url = root + 'cart/add.js';
    if (sectionsString) url += '?sections=' + sectionsString;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    })
      .then(function(response) { return response.json(); })
      .then(function(data) {
        if (data && data.sections && typeof HELPER_UTIL !== 'undefined' && typeof _EVENT_HELPER !== 'undefined') {
          HELPER_UTIL.dispatchCustomEvent(_EVENT_HELPER.triggerCartChange, document, { sections: data.sections });
        }
        setRecommendationButton(button, '+ ADD', false);
        scheduleDrawerLayoutRefresh(document.querySelector('drawer-cart'));
      })
      .catch(function(error) {
        console.error('Cart recommendation add error:', error);
        setRecommendationButton(button, '+ ADD', false);
        scheduleDrawerLayoutRefresh(document.querySelector('drawer-cart'));
      });
  }

  document.addEventListener('change', function(event) {
    var select = event.target && event.target.closest ? event.target.closest('.ccd-rec-variant-select') : null;
    if (select) updateRecommendationVariant(select);
  }, true);

  document.addEventListener('submit', submitRecommendationForm, true);

  document.addEventListener('DOMContentLoaded', function() {
    patchWhenReady();
    setTimeout(fixMoneySpaces, 250);
    scheduleDrawerLayoutRefresh(document.querySelector('drawer-cart'));
  });

  document.addEventListener('action:showDrawer', function() {
    document.querySelectorAll('drawer-cart').forEach(function(drawerCart) {
      activateRecommendations(drawerCart, false);
      scheduleDrawerLayoutRefresh(drawerCart);
    });
    setTimeout(fixMoneySpaces, 100);
  });

  document.addEventListener('action:cartrecommendations:show', function(event) {
    var drawerCart = event.target && event.target.closest ? event.target.closest('drawer-cart') : null;
    activateRecommendations(drawerCart || document.querySelector('drawer-cart'), false);
  });

  window.addEventListener('resize', function() {
    scheduleDrawerLayoutRefresh(document.querySelector('drawer-cart'));
  });

  patchWhenReady();
})();
